import { createContext } from 'react';

export const ModalContext = createContext({})
export const FunctionContext = createContext({})
export const FunctionGalleryContext = createContext({})
export const FunctionStoryContext = createContext({})
export const FunctionNotificationContext = createContext({})